import styled, { keyframes } from 'styled-components'

const TimelineContainer = styled.div`
  width: 100%;
  position: relative;
  padding: 10px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 25px;
    height: 100%;
    width: 4px;
    background: linear-gradient(90deg, #aa00de 0%, #ff5252 100%);
    background-position: center;
    background-size: 30px 100%;
  }
  @media (${({ theme }) => theme.mq.desktop}) {
    &:after {
      left: 50%;
      margin-left: -2px;
    }
  }
`

const animation = keyframes`
  0%,100% {
      transform: translateX(-50%) translatey(-50%) scale(1.0);
  }
  50% {
      transform: translateX(-50%) translatey(-50%) scale(0.5);
  }
`

const TimelineWrapper = styled.div`
  position: relative;
  margin: 2em 0;
  pointer-events: none;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
  @media (${({ theme }) => theme.mq.desktop}) {
    :nth-child(even) {
      display: flex;
      flex-direction: row-reverse;
    }
  }
  @media (${({ theme }) => theme.mq.desktop}) {
    margin: 4em 0;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
    &:not(:first-child) {
      margin-top: -130px;
    }
    &:not(:last-child) {
      min-height: 130px;
    }
  }
`

const TimelineDisk = styled.div`
  position: absolute;
  top: 10px;
  left: 2px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(
    90deg,
    rgb(170, 0, 222) 0%,
    rgb(255, 82, 82) 100%
  );
  background-size: 30px 100%;
  background-position: center;
  z-index: 10;

  @media (${({ theme }) => theme.mq.desktop}) {
    width: 30px;
    height: 30px;
    left: 50%;
    margin-left: -15px;
  }

  &:before {
    content: '';
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    height: 20px;
    width: 20px;
    background: ${({ theme }) => theme.color.ui2};
    border-radius: 50%;
    transform: translateX(-50%) translatey(-50%);
  }
  &:after {
    content: ${({ present }) => (present ? "''" : 'none')};
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    height: 10px;
    width: 10px;
    background: linear-gradient(
      90deg,
      rgb(170, 0, 222) 0%,
      rgb(255, 82, 82) 100%
    );
    background-size: 30px 100%;
    background-position: center;
    border-radius: 50%;
    animation: ${animation} 1.5s ease-in-out infinite;
  }
`
const TimelineCard = styled.div`
  position: relative;
  margin-left: 50px;
  background: ${({ theme }) => theme.color.ui3};
  padding: 10px;
  display: grid;
  grid-auto-rows: auto;
  grid-gap: 10px;
  pointer-events: auto;

  @media (${({ theme }) => theme.mq.desktop}) {
    color: white;
    margin-left: 0;
    padding: 10px;
    width: ${({ fullWidth }) => (fullWidth ? '100%' : 'calc(50% - 30px)')};
  }
`

const TimelineLink = styled.a`
  color: ${({ theme }) => theme.color.text1};
  text-decoration: none;
  font-size: 24px;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 10px;
  align-items: center;
`

const TimelineTitle = styled.h1`
  font-size: inherit;
  display: inline-block;
  margin: 0;
`

const TimelineInfo = styled.div`
  font-size: 14px;
  display: grid;
  grid-gap: 10px;
  background: ${({ theme }) => theme.color.ui4};
  padding: 5px 10px;

  @media (${({ theme }) => theme.mq.mobile}) {
    grid-auto-rows: 1fr;
  }

  @media (${({ theme }) => theme.mq.desktop}) {
    grid-template-columns: repeat(2, 1fr);
  }
`

const TimelineRole = styled.span`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 10px;
  align-items: center;
`

const TimelineDate = styled.span`
  display: grid;
  grid-template-columns: auto auto auto 1fr;
  grid-gap: 10px;
  align-items: center;
`

const TimelineDescription = styled.p`
  text-align: justify;
  font-size: 14px;
  padding: 5px;
`

const TimelineTechList = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  grid-gap: 10px;
  font-size: 12px;
`

const TimelineTechItem = styled.li`
  list-style: none;
  text-align: center;
  background: ${({ theme }) => theme.color.ui4};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
`

export {
  TimelineContainer,
  TimelineWrapper,
  TimelineDisk,
  TimelineCard,
  TimelineLink,
  TimelineTitle,
  TimelineInfo,
  TimelineRole,
  TimelineDate,
  TimelineDescription,
  TimelineTechList,
  TimelineTechItem,
}
